const CustomFormIds = {
  ADD_LOAN: "ADD_LOAN",
  ADD_BORROWER: "ADD_BORROWER",
  ADD_PAYMENT_DETAILS: "ADD_PAYMENT_DETAILS",
  EXPOSURE_GROUP: "EXPOSURE_GROUP",
  ADD_COMPLETION_STATEMENT: "ADD_COMPLETION_STATEMENT",
  ADD_PRICING_PERIMETER: "ADD_PRICING_PERIMETER",
};

export default CustomFormIds;
